import React, {useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import { Flex, GridWrapper, Block } from '../../../../components/common/StyledComponent/CommonStyledComponent.jsx';
import './aiTopics.scss';
import { Icon } from '@vds/icons';
import styled, { keyframes } from 'styled-components';
import {decodeHTML, dynamicImageUrl } from "../../../../utility/utils.js";


// const mockTopics = [
//     { id: 1, label: 'Winning customers', icon: 'custom-audience' },
//     { id: 2, label: 'Online marketing', icon: 'laptop-trends' },
//     { id: 3, label: 'Online marketing', icon: 'laptop-trends' },
//     { id: 4, label: 'Wellness', icon: 'emoji' },
//     { id: 5, label: 'Boost profits', icon: 'speed-monitoring' },
// ];
const GeneratingIcon = styled.svg`
  flex-shrink: 0;
  margin-top: 2px;
`;

// const relatedSearches = [
//     'How do I grow my business?',
//     'Sales growth',
//     'My sales are down this quarter',
//     'Increasing profits',
//     'Courses on growing my business',
//     'Generating sales leads',
//     'How do I improve my cash flow?',
//     'Ideas for growing my business',
//     'Setting sales goals',
//     'How to increase online sales',
// ];

const AiTopicCard = ({ topic, askAiData }) => {
    // Safely call the hook here!
    // const imageUrl = dynamicImageUrl(topic, topic.imageUrl, 'search_more_info_topics', 'typeAheadResImg');
let item = topic;
    return (
        <div 
            className="ai-topic-card"
            onClick={() => {
                if (item?.redirectUrl) {
                    window.location.href = item?.redirectUrl;
                }
            }}
            style={{ cursor: 'pointer' }}
            role={"button"}
            tabIndex={0}
            onKeyDown={(e) => {
                if (item.redirectUrl && (e.key === 'Enter' || e.key === ' ')) {
                    e.preventDefault();
                    window.location.href = item?.redirectUrl;
                }
            }}
        >
            <div className="ai-topic-card-inner">
                <div className="ai-topic-icon-wrap">
                    <img 
                        src={item?.imageUrl} 
                        alt={item?.title} 
                        width="32" 
                        height="32" 
                    />
                </div>
                <div className="ai-topic-info">
                    <span className="ai-topic-label-small micro font-eTX-bold ">
                        {item?.eyebrowText}
                    </span>
                    <span className="ai-topic-label title-sm">{item.title}</span>
                </div>
            </div>
        </div>
    );
};

function resourceTypeMapping(resource, aisearchJsonData=[], allTopicsObj = {}, currentOrigin = window.location.origin) {
  // 1. Sanitize the launchUrl by stripping out any hardcoded environments
  let cleanLaunchUrl = resource?.launchUrl || resource?.link || '';
  if (cleanLaunchUrl) {
    try {
      // If this parses successfully, it's an absolute URL (e.g., https://pilot-...)
      const parsedUrl = new URL(cleanLaunchUrl);
      console.log('parsedUrl', parsedUrl);
      // Extract just the relative path
      cleanLaunchUrl = parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
       console.log('cleanLaunchUrl', cleanLaunchUrl);
    } catch (e) {
      // If parsing fails, it's already a relative path, so we leave it as is
    }
  }

  if ((typeof cleanLaunchUrl === 'string' && cleanLaunchUrl.includes('askai')) || (resource?.type === 'page' && resource?.title === 'AI Search')) {
    return null;
  }

  // If the launchUrl points to a course or learning detail page, skip mapping entirely.
  if (typeof cleanLaunchUrl === 'string' && (cleanLaunchUrl.includes('course-details') || cleanLaunchUrl.includes('learning-details')  || cleanLaunchUrl.includes('instructor-details'))) {
    return null;
  }

  // 2. Use `cleanLaunchUrl` for all the subsequent checks instead of `resource.launchUrl`
  if (resource?.title && resource?.type && (resource.type === 'instructor' || resource.type === 'spotlight'  || resource.type === 'grantstories')) {
    return {
      eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.[resource.type]?.eyebrowText || '',
      imageUrl: `${ aisearchJsonData?.['typeaheadCardsMapping']?.[resource.type]?.aiImgUrl}` || `${resource?.imageUrl}` || '',
      title: resource?.title || '',
      redirectUrl: resource.type === 'instructor' ? `/instructor-details/${resource?.id}` : (resource.type === 'spotlight' || resource.type === 'grantstories') ? `${aisearchJsonData?.['typeaheadCardsMapping']?.[resource.type]?.link}` : '',
    };
  } else if (resource?.title && resource?.id && resource?.format === 'Quick Tip') {
    return {
      eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.['quicktips']?.eyebrowText || '',
      imageUrl: `${resource?.imageUrl}` || '',
      title: resource?.title || '',
      redirectUrl: `${cleanLaunchUrl}${resource?.id}` || '',
    };
  } else if (!resource?.id && typeof cleanLaunchUrl === 'string' && cleanLaunchUrl.includes('/funding')) {
    const fundingEyebrowKey = cleanLaunchUrl.includes('/funding/details') ? 'funding/details' : 'funding';
    return {
      eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.[fundingEyebrowKey]?.eyebrowText || '',
      imageUrl: aisearchJsonData?.['typeaheadCardsMapping']?.[fundingEyebrowKey]?.aiImgUrl || `${resource?.imageUrl}` || '',
      title: resource?.title || '',
      redirectUrl: `/${fundingEyebrowKey}`,
    };
  } else if (!resource?.id && typeof cleanLaunchUrl === 'string' && cleanLaunchUrl.includes('/customerSupport')) {
    const customerSupportSuffix = (cleanLaunchUrl.split('/customerSupport/')[1] || '').split(/[?#]/)[0].replace(/^\/+|\/+$/g, '');
    const customerSupportEyebrowKey = customerSupportSuffix ? `customerSupport/${customerSupportSuffix}` : 'customerSupport';
    return {
      eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.[customerSupportEyebrowKey]?.eyebrowText || '',
      imageUrl: aisearchJsonData?.['typeaheadCardsMapping']?.[customerSupportEyebrowKey]?.aiImgUrl || `${resource?.imageUrl}` || '',
      title: resource?.title || '',
      redirectUrl: `/${customerSupportEyebrowKey}`,
    };
  } else if (!resource?.id && typeof cleanLaunchUrl === 'string' && cleanLaunchUrl.includes('/results/')) {
    const resultsSuffix = (cleanLaunchUrl.split('/results/')[1] || '').split(/[?#]/)[0].replace(/^\/+|\/+$/g, '').toLowerCase();
    const resultsEyebrowKey = resultsSuffix ? `results/${resultsSuffix}` : 'results';
    // Match the topic name after /results/ against the AEM topics lookup map to pull its aiImgUrl
    const resultsTopicKey = resultsSuffix.split(' ').join('');
    const topicAiImgUrl = allTopicsObj?.[resultsTopicKey]?.aiImgUrl;
    return {
      eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.['results']?.eyebrowText || '',
      imageUrl: topicAiImgUrl || aisearchJsonData?.['typeaheadCardsMapping']?.['results']?.aiImgUrl || `${resource?.imageUrl}` || '',
      title: resource?.title || '',
      redirectUrl: `/${resultsEyebrowKey}`,
    };
  } else if (!resource?.id && typeof cleanLaunchUrl === 'string' && cleanLaunchUrl.includes('/category/')) {
    const categorySuffix = (cleanLaunchUrl.split('/category/')[1] || '').split(/[/?#]/)[0].trim().toLowerCase();
    const categoryEyebrowKey = categorySuffix ? `category${categorySuffix}` : '';
    return {
      eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.[categoryEyebrowKey]?.eyebrowText || aisearchJsonData?.['typeaheadCardsMapping']?.['categoryevents']?.eyebrowText || '',
      imageUrl: aisearchJsonData?.['typeaheadCardsMapping']?.[categoryEyebrowKey]?.aiImgUrl || `${resource?.imageUrl}` || '',
      title: resource?.title || '',
      redirectUrl: `${categorySuffix ? `/category/${categorySuffix}` : ''}`,
    };
  } 
//   else if (!resource?.id && typeof cleanLaunchUrl === 'string') {
//     const normalizedLaunchUrl = cleanLaunchUrl.trim().replace(/\/+$/, '');
    
//     // 3. Rebuild the final URL dynamically with the current environment's origin
//     const finalRedirectUrl = currentOrigin + (normalizedLaunchUrl.startsWith('/') ? '' : '/') + normalizedLaunchUrl;

//     return {
//       eyebrowText: aisearchJsonData?.['typeaheadCardsMapping']?.['other']?.eyebrowText || '',
//       imageUrl: aisearchJsonData?.['typeaheadCardsMapping']?.['other']?.aiImgUrl || `${resource?.imageUrl}` || '',
//       title: aisearchJsonData?.['typeaheadCardsMapping']?.['other']?.label || resource?.title || '',
//       redirectUrl: finalRedirectUrl,
//     };
//   }
  return null;
}


const AiTopics = ({ onAskAI, apiTotalCount, currentQueryNew, askAiData, topics = [],fetchedResults }) => {
    console.log("^^fetchedResults,onAskAI, apiTotalCount, currentQueryNew, askAiData, topics",fetchedResults, onAskAI, apiTotalCount, currentQueryNew, askAiData, topics);
    
     const ai_searchJsonData = JSON.parse(localStorage.getItem('aisearch_landingpage_data')) || {};

    const courseCxAemData = useSelector((state) => state?.Aem?.courseCxJsonData);

    // Build a lookup map of AEM topics keyed by normalized topic name (lowercase, no spaces)
    const aemTopicsArray = Array.isArray(courseCxAemData)
        ? courseCxAemData
        : courseCxAemData?.allTopics?.allTopicsData || [];
    const allTopicsObj = {};
    aemTopicsArray.forEach((item) => {
        if (item?.value) {
            const normalizedKey = item.value.toLowerCase().split(' ').join('');
            allTopicsObj[normalizedKey] = item;
        }
    });

    // Map each fetched result through resourceTypeMapping and collect the valid results.
    const mappedResources = (Array.isArray(fetchedResults) ? fetchedResults : []).reduce((acc, item) => {
         if (item?.launchUrl && typeof item.launchUrl === 'string' && item.launchUrl.includes('/es/')) {
                console.log("Excluding item due to Spanish launchUrl (/es/):", item);
                return item;
              }
              if (item?.localizeData && item.localizeData.locale === 'es-ES') {
                console.log("Excluding item due to Spanish localizeData (es-ES):", item);
                return item;
              }
        const mapped = resourceTypeMapping(item, ai_searchJsonData, allTopicsObj);
        if (mapped) {
            acc.push(mapped);
        }
        return acc;
    }, []);
    console.log("^^mappedResources", mappedResources);
    
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
    const [popularPills, setPopularPills] = useState([]);
    const [query, setQuery] = useState('');

     useEffect(() => {
        setPopularPills(localStorage.getItem('popSearch') ? JSON.parse(localStorage.getItem('popSearch')) : popularPills);
    }, []);

    const handlePopularClick = (pill) => {
        setQuery(pill)
        window.location.href = "/askai?q=" + encodeURIComponent(pill);
    }
    const handleAskAIClick = () => {
        let query = "";
        try {
            if(currentQueryNew && currentQueryNew.trim() !== "") {
                query = currentQueryNew;
            }else {
                const params = new URLSearchParams(window.location.search || "");
                query = params.get("q") || "";
            }
           
        } catch (e) {}
        try { window.isAskAIActive = true; } catch (e) {}
        window.location.href = `/askai${query ? "?q=" + encodeURIComponent(query) : ""}`;
    }

    // 2. Filter API topics and apply the mapping logic
    const renderableTopics = topics.reduce((acc, tag) => {
        const normalizedTag = tag.toLowerCase().split(' ').join('');
        
        // Match API topic against AEM lookup map; discard if not found
        if (allTopicsObj[normalizedTag]) {
            const topicData = allTopicsObj[normalizedTag];
            console.log("topicData", topicData);
            const isNonClickable = topicData?.noResultsPage === 'true';
            let lng = localStorage.getItem("lng") || 'en';
            // Build the URL applying the /results/ routing logic
            const basePath = lng === 'en' ? `/results/` : `/es/results/`;
            const redirectUrl = `${basePath}${normalizedTag}`;
            

            acc.push({
                id: normalizedTag,
                title: topicData?.label || tag,
                icon: topicData?.aiImgUrl || 'custom-audience', 
                imageUrl: topicData?.aiImgUrl || '', // Capturing the AEM image URL
                isNonClickable: isNonClickable,
                redirectUrl: redirectUrl
            });
        }
        return acc;
    }, []);

    return (
        <Block className="ai-topics">
            {(mappedResources.length > 0 && apiTotalCount > 0) ? (
                <>
                    {/* Topics section */}
                    <h3 className="ai-topics-heading vds-title-sm mobile-vds-title-sm font-eDS-bold">
                        {decodeHTML(askAiData?.resultsPageTexts?.classicSearchTexts?.moreInfoText)}
                    </h3>

                    <GridWrapper className="ai-topics-grid">
                        {mappedResources.slice(0, 6).map((item, index) => (
                            <AiTopicCard 
                                key={index} 
                                topic={item} 
                                askAiData={askAiData} 
                            />
                        ))}
                    </GridWrapper>
                </>
            ) :  <>
            {/* <div className="null-results-ai-banner mb-16X sm-mb-12X">
                <div className="null-results-ai-icon">
                    <GeneratingIcon
                        width='16'
                        height='16'
                        viewBox='0 0 62 68'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <path
                            d='M33.4065 67.3684C31.8162 67.3684 30.3884 66.3418 29.6807 65.3235L29.5182 65.0622C28.8722 63.9718 28.6006 62.8979 28.4072 61.968C28.2776 61.4084 28.0842 60.5135 27.862 59.4766C27.3354 57.0284 26.6153 53.6771 26.0886 51.7761C25.887 51.0849 25.3995 50.192 24.7144 50.0439C23.9881 49.8793 22.8134 49.6283 21.4968 49.3444C19.4086 48.8959 16.9686 48.3713 15.4071 48.0092C13.8292 47.6656 12.1566 47.2398 11.0313 46.5526C10.7761 46.4169 10.5972 46.2646 10.4984 46.1803C9.47388 45.3285 8.92046 44.1435 8.92046 42.8824C8.92046 41.6213 9.47388 40.4342 10.4408 39.6298C10.5828 39.5105 10.772 39.35 11.0292 39.2122C12.1628 38.5168 13.8456 38.091 15.3536 37.768C16.9357 37.4018 19.3119 36.8895 21.3713 36.4472C22.7373 36.153 23.9635 35.8896 24.7 35.723C25.3995 35.5708 25.887 34.6779 26.0969 33.9578C26.6153 32.0857 27.3354 28.7343 27.862 26.2861C28.0842 25.2493 28.2776 24.3543 28.4155 23.7557C28.6006 22.8669 28.8722 21.7951 29.4174 20.8693L29.6663 20.4619C30.3864 19.423 31.8141 18.3943 33.4065 18.3943C35.0029 18.3943 36.4287 19.425 37.1343 20.4475L37.2927 20.7026C37.9449 21.8053 38.2144 22.8751 38.4057 23.7989C38.5374 24.3687 38.7349 25.2925 38.9653 26.3602C39.4879 28.7858 40.2017 32.1063 40.7222 33.9866C40.9239 34.6758 41.4135 35.5708 42.0965 35.7189C42.8495 35.8896 44.0818 36.155 45.454 36.4492C47.5093 36.8915 49.8772 37.4018 51.4058 37.7556C52.9611 38.091 54.644 38.5148 55.7796 39.2101C56.0306 39.3459 56.2096 39.4961 56.3084 39.5784C57.3391 40.4404 57.8925 41.6254 57.8925 42.8824C57.8925 44.1394 57.3391 45.3224 56.3763 46.1309C56.2261 46.2543 56.0368 46.4127 55.7838 46.5506C54.6584 47.2398 52.9858 47.6656 51.4881 47.9907C49.8464 48.3692 47.4126 48.8938 45.3285 49.3403C44.0057 49.6262 42.8248 49.8793 42.1089 50.0398C41.4135 50.192 40.9239 51.0869 40.714 51.807C40.2017 53.6565 39.4879 56.977 38.9653 59.4025C38.7349 60.4703 38.5374 61.394 38.3954 62.0091C38.2144 62.8897 37.9449 63.9615 37.3915 64.8955L37.1652 65.2741C36.4266 66.3398 35.0009 67.3684 33.4065 67.3684ZM53.6063 42.8078C53.3113 42.6182 52.5529 42.3021 50.5727 41.8809C48.9506 41.5016 46.5911 40.996 44.5687 40.5748C43.1782 40.2798 41.9353 40.0059 41.177 39.8373C39.0912 39.3739 37.4059 37.6254 36.6686 35.1395C36.0998 33.117 35.4045 29.8517 34.8569 27.2394C34.6251 26.2072 34.4356 25.3013 34.2881 24.6903C34.1828 24.1426 34.0142 23.4264 33.7614 23.005C33.7614 23.005 33.7217 22.9101 33.6631 22.8295C33.6266 22.7794 33.4908 22.5888 33.4065 22.5677C33.3455 22.5937 33.2061 22.7347 33.143 22.8189C33.106 22.8658 33.0513 22.9519 32.9819 23.1103C32.8134 23.4053 32.6448 24.1005 32.5395 24.6481C32.392 25.2803 32.2025 26.165 31.9708 27.1762C31.4441 29.6621 30.7067 33.0959 30.1589 35.1184C29.4217 37.6254 27.7153 39.3739 25.6086 39.8373C24.8712 40.0059 23.6494 40.2587 22.2589 40.5748C20.2155 40.996 17.8771 41.5016 16.3602 41.8598C14.2535 42.3021 13.4952 42.6182 13.2213 42.8078L13.116 42.892L13.167 42.9281L13.2353 42.9647C13.5092 43.1544 14.2535 43.4398 16.2127 43.8821C17.8981 44.2614 20.3208 44.7881 22.3853 45.2304C23.7125 45.5043 24.9133 45.7571 25.6297 45.9257C27.7152 46.3891 29.4217 48.1376 30.1379 50.6235C30.7067 52.6671 31.4441 56.101 31.9708 58.5868C32.2025 59.598 32.392 60.4827 32.5184 61.0727C32.6448 61.6625 32.8134 62.3577 33.0451 62.758C33.0662 62.7791 33.0785 62.8357 33.1547 62.9305C33.1935 62.9807 33.3223 63.1362 33.4065 63.1573C33.4818 63.1406 33.6045 63.0018 33.6677 62.9175C33.7215 62.8472 33.7499 62.7876 33.8245 62.6527C34.0142 62.3366 34.1828 61.6204 34.2881 61.1149C34.4356 60.4617 34.6251 59.5558 34.8569 58.5236C35.4045 55.9113 36.0998 52.646 36.6686 50.6446C37.4059 48.1377 39.0912 46.3891 41.1979 45.9257C41.9142 45.7571 43.1151 45.5043 44.4423 45.2304C46.5068 44.7881 48.9084 44.2614 50.4463 43.9032C52.5529 43.4398 53.3113 43.1448 53.6063 42.9552L53.6881 42.8908L53.6695 42.871L53.6063 42.8078ZM28.2282 12.4549C28.8722 12.9919 29.2404 13.7819 29.2404 14.6212C29.2404 15.4565 28.8742 16.2445 28.2344 16.7814L27.9176 17.0098L27.9197 17.0139C27.2058 17.4768 26.1483 17.7463 25.2061 17.9479C24.2597 18.166 22.797 18.4807 21.5626 18.7461L19.7686 19.135C19.5691 19.1802 19.3366 19.5156 19.2173 19.9209C18.9169 21.0092 18.5096 22.9101 18.201 24.342L17.8738 25.8459C17.7607 26.3849 17.592 27.0474 17.2443 27.6316L17.1106 27.8538C16.5181 28.7138 15.5511 29.2425 14.6212 29.2425C13.6893 29.2425 12.7224 28.7138 12.1566 27.8929L12.027 27.681C11.6484 27.0412 11.4818 26.3828 11.3625 25.815L11.0436 24.3585C10.7371 22.9245 10.3277 21.0153 10.017 19.9003C9.90385 19.5156 9.67138 19.1802 9.47799 19.137L7.64699 18.74C6.41878 18.4766 4.9725 18.1639 4.05083 17.95C3.16413 17.7607 2.18897 17.5159 1.48331 17.1106L1.28723 16.9898L1.04305 16.8123C0.3662 16.2445 0 15.4565 0 14.6212C0 13.7819 0.368257 12.9919 1.01219 12.4549L1.3249 12.2307L1.32285 12.2286C2.02439 11.7719 3.07361 11.5044 4.00557 11.3008C4.9581 11.0806 6.37352 10.7761 7.58527 10.5149L9.47182 10.1075C9.67138 10.0623 9.90385 9.72692 10.0232 9.32164C10.3277 8.22509 10.7371 6.31797 11.0436 4.88404L11.3687 3.39661C11.4818 2.86171 11.6484 2.20337 11.992 1.61704L12.1545 1.35165C12.7224 0.528727 13.6893 0 14.6212 0C15.5511 0 16.5181 0.528727 17.0838 1.34959L17.2093 1.55326C17.594 2.19926 17.7607 2.85965 17.88 3.42747L18.201 4.90049C18.5096 6.33238 18.9169 8.23127 19.2234 9.34632C19.3366 9.72692 19.5691 10.0623 19.7624 10.1055L21.6243 10.5087C22.8443 10.772 24.2741 11.0786 25.1876 11.2905C26.1031 11.49 27.0741 11.7369 27.7695 12.1381L27.9264 12.2353L28.1974 12.4302L28.2282 12.4549ZM3.734 14.6212C3.97059 14.6891 4.28536 14.7694 4.69888 14.8578C5.6761 15.0841 7.10181 15.3907 8.3115 15.6499L10.1631 16.0531C11.5127 16.3494 12.5969 17.4624 13.0556 19.0321C13.391 20.2377 13.821 22.2353 14.1337 23.6939L14.4505 25.1382C14.4772 25.274 14.5369 25.5579 14.6151 25.7883C14.7097 25.5373 14.7632 25.2781 14.7858 25.169L15.1129 23.6775C15.4318 22.188 15.8577 20.213 16.1786 19.0547C16.6436 17.4624 17.7278 16.3494 19.0835 16.0511L20.9001 15.6561C22.1139 15.3948 23.5561 15.0862 24.4737 14.8722C24.9222 14.7755 25.2575 14.6912 25.5085 14.6212C25.274 14.5534 24.9674 14.4752 24.5642 14.3888C23.5746 14.1604 22.1633 13.858 20.9598 13.5988L19.0774 13.1894C17.7278 12.8931 16.6436 11.7801 16.1848 10.2104C15.8577 9.02744 15.4318 7.05449 15.1129 5.565L14.792 4.10432C14.7653 3.96854 14.7056 3.68257 14.6274 3.45421C14.5328 3.70314 14.4793 3.96442 14.4567 4.07346L14.1337 5.54854C13.8127 7.04009 13.3848 9.02538 13.0618 10.1878C12.5969 11.7801 11.5127 12.8931 10.1569 13.1914L8.24978 13.6049C7.05243 13.8621 5.65964 14.1625 4.76471 14.3682C4.31622 14.4669 3.98294 14.5513 3.734 14.6212ZM61.1081 13.0227C61.5895 13.426 61.8651 14.0185 61.8651 14.6459C61.8651 15.2734 61.5895 15.8659 61.1081 16.2691L60.8571 16.4502C60.3695 16.7608 59.7029 16.9337 59.0549 17.0756C58.4603 17.2134 57.5818 17.4027 56.8145 17.5673L55.5431 17.843C55.541 17.8512 55.4587 17.9602 55.4052 18.1413C55.2159 18.8243 54.9608 20.0196 54.7633 20.931L54.5453 21.935C54.4691 22.297 54.3539 22.7496 54.1091 23.1652L53.9918 23.3566C53.5722 23.9593 52.8542 24.3502 52.1608 24.3502C51.4675 24.3502 50.7495 23.9593 50.3298 23.3566L50.2085 23.157C49.9636 22.7373 49.8464 22.2682 49.7703 21.9062L49.5748 21.0071C49.3773 20.0854 49.1099 18.8428 48.9103 18.1187C48.863 17.9582 48.7807 17.8512 48.7519 17.8286L47.536 17.5714C46.7625 17.4068 45.8717 17.2134 45.2956 17.0797C44.6723 16.9439 44.0571 16.7876 43.584 16.5201L43.2404 16.2897C42.7302 15.8597 42.4566 15.2693 42.4566 14.6459C42.4566 14.0226 42.7302 13.4321 43.2075 13.0289L43.4667 12.8396C43.9543 12.531 44.6208 12.3582 45.2668 12.2183C45.8922 12.0743 46.8263 11.8727 47.6163 11.704L48.7869 11.4489C48.7807 11.4427 48.863 11.3357 48.9144 11.1547C49.1119 10.4429 49.3794 9.19203 49.5789 8.2683L49.7764 7.36103C49.8464 7.02363 49.9636 6.55456 50.2085 6.13488L50.3298 5.93532C51.1692 4.72974 53.1525 4.72974 53.9918 5.93532L54.1091 6.12665C54.3539 6.54222 54.4691 6.99483 54.5514 7.38572L54.7613 8.34647C54.9567 9.25992 55.2159 10.4634 55.4114 11.1732C55.4587 11.3337 55.5431 11.4427 55.5719 11.4653L56.7404 11.7102C57.5242 11.8789 58.4397 12.0764 59.0261 12.2101C59.6494 12.3459 60.2646 12.5043 60.7377 12.7717L60.9386 12.8956L61.1081 13.0227ZM46.4703 14.6459C46.9847 14.7611 47.5648 14.8846 48.0894 14.9977L49.3629 15.2755C50.336 15.4853 51.1178 16.2815 51.4449 17.4007C51.6589 18.1783 51.9407 19.4847 52.1485 20.4516L52.1608 20.5072L52.1896 20.3776C52.3954 19.4168 52.669 18.1598 52.8727 17.4192C53.2101 16.2794 53.9918 15.4853 54.9732 15.2714L56.261 14.9916C56.7857 14.8784 57.3638 14.755 57.8534 14.6459C57.3247 14.5287 56.7239 14.4011 56.189 14.2859L54.9629 14.0205C53.9898 13.8066 53.208 13.0104 52.8788 11.8953C52.6669 11.1279 52.3933 9.86271 52.1855 8.89989L52.1608 8.78468L52.1526 8.82377C51.9448 9.79276 51.6609 11.1074 51.449 11.8727C51.1178 13.0083 50.3381 13.8045 49.3547 14.0205L48.1697 14.2777C47.6163 14.397 46.9929 14.5307 46.4703 14.6459Z'
                            fill='#000000'
                        />
                    </GeneratingIcon>
                </div>
                <p className="null-results-ai-text title-md  font-eDS-bold">
                    Not finding what you want? Try our new AI-assisted search for enhanced results and guided recommendations.
                </p>
                <button className="null-results-ai-btn body-lg font-eDS-bold " onClick={handleAskAIClick}>
                    Ask AI
                </button>
            </div> */}

            {/* Related searches section */}
            {/* <h3 className="ai-topics-related-heading title-md mobile-vds-title-sm font-eDS-bold ">
                {decodeHTML(askAiData?.resultsPageTexts?.popSchText)}
            </h3>

            <Flex className="ai-topics-related-list">
                 {popularPills?.slice(0, isMobile ? 5 : 10)?.map((pill) => (
                <button
                  key={pill}
                  className='ai-related-chip body-sm font-eTX-bold'
                  type='button'
                  aria-label={pill}
                  onClick={() => handlePopularClick(pill)}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      event.preventDefault();
                      handlePopularClick(pill);
                    }
                  }}
                >
                  {pill} 
                </button>
              ))}
            </Flex> */}
            </>}
        </Block>
    );
};

export default AiTopics;